export const Strings = {
  mobileNoLabel:
    'Enter the phone number of the Telegram user who is a member of source chats, along with the country code:',
  mobileNoErrMsg:
    'Please enter a valid phone number, including the country code.',
  enterCodeLabel:
    'We sent a login code to your Telegram account. Please enter your login code:',
  codeErrMsg: 'Please enter a valid login code from Telegram',
  passwordLabel:
    'Your Telegram account uses a 2FA password to login. Please enter the password: What is 2FA password? This is how you set a password in Telegram account:',
  passwordErrorMsg: 'Please enter a valid password',
  successPasswordMsg: `You have successfully logged in to AageBot's @auto_forwarder_bot. You are being redirected to the bot. Please click the button below to do it now`,
  somethingWentWrongMsg: `Uh-oh...`,
};
